module.exports = __webpack_public_path__ + "img/emm_icon04.0d00b78c.png";